import { render, staticRenderFns } from "./materialForm.vue?vue&type=template&id=4d3c038c&"
import script from "./materialForm.vue?vue&type=script&lang=js&"
export * from "./materialForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports